var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTyping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 120,
    viewBox: "0 0 100 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 2,
    width: 77,
    height: 116,
    fill: "#D8ECDF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 36,
    width: 28,
    height: 27,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 33,
    width: 6,
    height: 6,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 33,
    width: 6,
    height: 6,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 60,
    width: 6,
    height: 6,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 60,
    width: 6,
    height: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9549 83.8764C61.3965 83.8764 69.8381 80.7953 76.3966 74.5358C90.033 61.6277 90.6175 40.0277 77.6628 26.4061C64.7082 12.7845 43.1172 12.2007 29.4807 25.1412C21.6235 32.5682 17.8248 43.0115 19.091 53.7791C19.8703 60.6223 22.6625 66.8818 27.143 72.0709L0 97.7574L2.24027 100.093L29.3833 74.3736C35.9418 80.6655 44.4159 83.8764 52.9549 83.8764ZM22.3053 53.3899C21.169 43.6601 24.6105 34.2223 31.721 27.4764C37.6626 21.8331 45.325 19.0439 52.9549 19.0439C61.1367 19.0439 69.2861 22.2547 75.3576 28.6439C87.046 40.9682 86.559 60.525 74.2212 72.2007C61.8835 83.9088 42.3055 83.3899 30.6171 71.0655C25.9093 66.1358 23.0521 60.0385 22.3053 53.3899Z",
    fill: "#679E7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8311 0V27.5676H22.0778V3.24324H96.7536V116.757H22.0778V92.4324H18.8311V120H100V0H18.8311Z",
    fill: "#679E7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3898 103.785H33.4414V107.028H85.3898V103.785Z",
    fill: "#679E7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3898 90.8125H33.4414V94.0557H85.3898V90.8125Z",
    fill: "#679E7C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.534 31.8043H63.678C63.2028 31.8043 62.8197 32.1874 62.8197 32.6627V35.2341H43.9685V32.6627C43.9685 32.1909 43.5854 31.8043 43.1102 31.8043H36.2577C35.7825 31.8043 35.3994 32.1874 35.3994 32.6627V39.5186C35.3994 39.9903 35.7825 40.3769 36.2577 40.3769H38.8292V59.2282H36.2577C35.7825 59.2282 35.3994 59.6112 35.3994 60.0865V66.9425C35.3994 67.4142 35.7825 67.8008 36.2577 67.8008H43.1137C43.589 67.8008 43.972 67.4177 43.972 66.9425V64.371H62.8233V66.9425C62.8233 67.4142 63.2063 67.8008 63.6816 67.8008H70.5375C71.0128 67.8008 71.3959 67.4177 71.3959 66.9425V60.0865C71.3959 59.6148 71.0128 59.2282 70.5375 59.2282H67.9661V40.3769H70.5375C71.0128 40.3769 71.3959 39.9939 71.3959 39.5186V32.6591C71.3959 32.1874 71.0128 31.8008 70.5375 31.8008L70.534 31.8043ZM37.1161 33.5174H42.2589V38.6603H37.1161V33.5174ZM42.2589 66.077H37.1161V60.9342H42.2589V66.077ZM69.6792 66.077H64.5364V60.9342H69.6792V66.077ZM66.253 59.2211H63.6816C63.2063 59.2211 62.8233 59.6041 62.8233 60.0794V62.6508H43.972V60.0794C43.972 59.6077 43.589 59.2211 43.1137 59.2211H40.5423V40.3698H43.1137C43.589 40.3698 43.972 39.9868 43.972 39.5115V36.9401H62.8233V39.5115C62.8233 39.9832 63.2063 40.3698 63.6816 40.3698H66.253V59.2211ZM69.6792 38.6567H64.5364V33.5139H69.6792V38.6567Z",
    fill: "#679E7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2513 40.3711H46.5429C46.0676 40.3711 45.6846 40.7541 45.6846 41.2294V44.6556C45.6846 45.1273 46.0676 45.514 46.5429 45.514C47.0182 45.514 47.4012 45.1309 47.4012 44.6556V42.0842H52.5441V57.5092H49.9726C49.4974 57.5092 49.1143 57.8923 49.1143 58.3675C49.1143 58.8428 49.4974 59.2259 49.9726 59.2259H56.8286C57.3039 59.2259 57.6869 58.8428 57.6869 58.3675C57.6869 57.8923 57.3039 57.5092 56.8286 57.5092H54.2572V42.0842H59.4V44.6556C59.4 45.1273 59.7831 45.514 60.2584 45.514C60.7336 45.514 61.1167 45.1309 61.1167 44.6556V41.2294C61.1167 40.7577 60.7336 40.3711 60.2584 40.3711H60.2513Z",
    fill: "#679E7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTyping);
export default __webpack_public_path__ + "static/media/iconTyping.eb5d8b58863a001325eaaf3931a9f18e.svg";
export { ForwardRef as ReactComponent };